import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "./index";
import UnitType from "../features/rapidstor/entities/UnitType";
import Location from "../features/rapidstor/entities/Location";
import Descriptor from "../features/rapidstor/entities/Descriptor";

export interface UnitData {
  location: Location;
  unitType: UnitType;
  descriptor: Descriptor;
  reservation: boolean;
}

interface State {
  unitData: UnitData | null;
  startTime: number | null;
  googleClickId: string | null;
}

const initialState: State = {
  unitData: null,
  startTime: null,
  googleClickId: null,
};

export const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    setUnitData: (state, action: { payload: UnitData; type: string }) => {
      state.unitData = action.payload;
    },
    setStartTime: (state, action: { payload: number | null; type: string }) => {
      state.startTime = action.payload;
    },
    setGoogleClickId: (state, action: { payload: string | null; type: string }) => {
      state.googleClickId = action.payload;
    },
  },
});

export const { setUnitData, setStartTime, setGoogleClickId } = bookingSlice.actions;

export const selectUnitData = (state: RootState) => state.booking.unitData;
export const selectStartTime = (state: RootState) => state.booking.startTime;
export const selectGoogleClickId = (state: RootState) => state.booking.googleClickId;
